import * as Sentry from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

// Initialize Sentry (skip on localhost)
const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

if (!isLocalhost) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.sentry.environment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.6,
  });
}

// Handle ?token= in URL (used for cross-app auth)
const url = new URL(window.location.href);
const token = url.searchParams.get('token');
if (token) {
  // Store a temporary user so auth can refresh from API
  const tempUser = {
    token,
    client_id: '',
    email: '',
    id: '',
    name: '',
    roles: [],
    options: {},
  };
  localStorage.setItem('com.tm.iam.currentUser', JSON.stringify(tempUser));

  // Clean the token from the URL
  url.searchParams.delete('token');
  window.history.replaceState({}, '', url.toString());
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
